import { NavItem } from 'types';

import { Button } from 'components/Button';
import { Dropdown } from 'components/Dropdown';

import * as S from './Sidebar.styles';
import { StyledSidebarProps } from './Sidebar.styles';

type SidebarProps = StyledSidebarProps & {
  data: NavItem[];
};

export function Sidebar(props: SidebarProps): React.ReactElement {
  const { data, type, isOpen } = { ...props };

  const navDataMapped = data?.map((item: NavItem) => (
    <S.Li key={item.label}>
      {item.list ? (
        <Dropdown
          motive="navigation"
          itemMotive="navigationSecondary"
          hasAnimation
          label={item.label}
          items={item.list}
          scale="s"
        />
      ) : (
        item.to && (
          <Button scale="s" motive="navigation" fontWeight="bold" asLink to={item.to}>
            {item.label}
          </Button>
        )
      )}
    </S.Li>
  ));

  return (
    <S.Container type={type} isOpen={isOpen} data-testid="sidebar">
      <S.Inner>
        <S.Ul>{navDataMapped}</S.Ul>
      </S.Inner>
    </S.Container>
  );
}
